// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"276a90f2","352":"558b4a56","363":"8fcd8422"}[chunkId] + ".chunk.js";
};